import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface IProps {
  title?: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  showDivider?: boolean;
}

const BookingStepLayout: FC<IProps> = ({ 
  title, 
  description, 
  children, 
  footer,
  showDivider = true 
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 3,
      }}
    >
      {/* Header Section */}
      {(title || description) && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {title && (
            <Typography
              sx={{
                fontFamily: 'Tajawal',
                fontSize: '20px',
                fontWeight: 500,
                lineHeight: '28px',
                color: '#0F172A',
                textAlign: 'right',
              }}
            >
              {title}
            </Typography>
          )}
          {description && (
            <Typography
              sx={{
                fontFamily: 'Tajawal',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
                color: '#64748B',
                textAlign: 'right',
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
      )}

      {/* Divider */}
      {showDivider && (title || description) && (
        <Box
          sx={{
            width: '100%',
            height: '1px',
            backgroundColor: '#E2E8F0',
          }}
        />
      )}

      {/* Body Section */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          gap: 2,
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#F1F5F9',
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#CBD5E1',
            borderRadius: '3px',
            '&:hover': {
              background: '#94A3B8',
            },
          },
        }}
      >
        {children}
      </Box>

      {/* Footer Section */}
      {footer && (
        <>
          {/* Divider before footer */}
          {showDivider && (
            <Box
              sx={{
                width: '100%',
                height: '1px',
                backgroundColor: '#E2E8F0',
              }}
            />
          )}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
              pt: 1,
            }}
          >
            {footer}
          </Box>
        </>
      )}
    </Box>
  );
};

export default BookingStepLayout;
